/* LATAM Alpha theme instrumentation and article UX */
(function () {
    'use strict';

    const article = document.querySelector('.la-article');
    const content = document.querySelector('[data-la-article-content]');
    const dataLayer = window.dataLayer = window.dataLayer || [];
    const emitted = new Set();

    function wordBand(count) {
        if (count < 650) return 'under-650';
        if (count < 1000) return '650-999';
        if (count < 1400) return '1000-1399';
        if (count < 1800) return '1400-1799';
        return '1800-plus';
    }

    const words = content ? content.innerText.trim().split(/\s+/).filter(Boolean).length : 0;
    const dimensions = {
        content_type: article ? article.dataset.contentType || 'standard-analysis' : 'non-article',
        word_count_band: wordBand(words),
        site_locale: document.documentElement.lang || 'unknown'
    };

    function emit(event, detail) {
        dataLayer.push(Object.assign({event: event}, dimensions, detail || {}));
    }

    document.querySelectorAll('[data-members-form]').forEach(function (form) {
        form.addEventListener('submit', function () {
            emit('newsletter_submit', {placement: form.closest('.la-article-newsletter') ? 'article_end' : 'homepage'});
        }, {once: true});
    });

    document.querySelectorAll('[data-la-related-link]').forEach(function (link) {
        link.addEventListener('click', function () {
            emit('related_click', {destination_url: link.href});
        });
    });

    if (!article || !content) return;

    emit('article_view', {word_count: words});

    const share = document.querySelector('[data-la-share]');
    if (share) {
        share.addEventListener('click', async function () {
            const payload = {title: share.dataset.shareTitle, url: share.dataset.shareUrl};
            if (navigator.share) {
                try {
                    await navigator.share(payload);
                    emit('share_click', {share_method: 'native'});
                } catch (error) {
                    if (error && error.name !== 'AbortError') emit('share_error', {share_method: 'native'});
                }
            } else if (navigator.clipboard) {
                await navigator.clipboard.writeText(payload.url);
                share.textContent = '✓';
                emit('share_click', {share_method: 'clipboard'});
            }
        });
    }

    content.querySelectorAll('a[href]').forEach(function (link) {
        let url;
        try {
            url = new URL(link.href, window.location.href);
        } catch (error) {
            return;
        }
        if (url.hostname && url.hostname !== window.location.hostname) {
            link.addEventListener('click', function () {
                emit('outbound_source_click', {source_domain: url.hostname, destination_url: url.href});
            });
        }
    });

    const progress = document.querySelector('[data-la-progress]');
    const milestones = [25, 50, 75, 90];
    let ticking = false;

    function updateProgress() {
        const rect = content.getBoundingClientRect();
        const start = window.scrollY + rect.top;
        const end = start + content.offsetHeight - window.innerHeight;
        const ratio = end > start ? Math.max(0, Math.min(1, (window.scrollY - start) / (end - start))) : 1;
        if (progress) progress.style.width = (ratio * 100).toFixed(1) + '%';
        milestones.forEach(function (mark) {
            if (ratio * 100 >= mark && !emitted.has(mark)) {
                emitted.add(mark);
                emit('article_scroll', {scroll_percent: mark});
            }
        });
        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(updateProgress);
            ticking = true;
        }
    }, {passive: true});
    updateProgress();

    const complete = document.querySelector('[data-la-article-complete]');
    if (complete && 'IntersectionObserver' in window) {
        const completeObserver = new IntersectionObserver(function (entries) {
            if (entries.some(function (entry) { return entry.isIntersecting; })) {
                emit('article_complete', {word_count: words});
                completeObserver.disconnect();
            }
        }, {threshold: 0.5});
        completeObserver.observe(complete);
    }

    const toc = document.querySelector('[data-la-toc]');
    const headings = Array.from(content.querySelectorAll('h2'));
    if (toc && headings.length) {
        headings.forEach(function (heading, index) {
            if (!heading.id) heading.id = 'section-' + (index + 1);
            const link = document.createElement('a');
            link.href = '#' + heading.id;
            link.textContent = heading.textContent;
            toc.appendChild(link);
        });

        if ('IntersectionObserver' in window) {
            const links = Array.from(toc.querySelectorAll('a'));
            const headingObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    links.forEach(function (link) {
                        link.classList.toggle('is-active', link.hash === '#' + entry.target.id);
                    });
                });
            }, {rootMargin: '-20% 0px -65% 0px'});
            headings.forEach(function (heading) { headingObserver.observe(heading); });
        }
    }
})();
